/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect, useState } from "react";
import {
  Heading,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { dateFormat } from "../../utils/constants";

export function CustomerDetails({ customer }) {
  return (
    <form>
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Customer Information
      </Heading>
      <FormControl>
        <FormLabel>Client Id</FormLabel>
        <Input readOnly value={customer.clientId} />
      </FormControl>
      <FormControl>
        <FormLabel>Name</FormLabel>
        <Input readOnly value={customer.name} />
      </FormControl>
      <FormControl>
        <FormLabel>Short Name</FormLabel>
        <Input readOnly value={customer.shortName} />
      </FormControl>
      <FormControl>
        <FormLabel>Customer Type</FormLabel>
        <Input readOnly value={customer.customerType} />
      </FormControl>
      <FormControl>
        <FormLabel>Customer Code</FormLabel>
        <Input readOnly value={customer.customerCode} />
      </FormControl>
      <FormControl>
        <FormLabel>Status</FormLabel>
        <Input readOnly value={customer.status} />
      </FormControl>
      <div style={{ width: "100%" }} />
      <FormControl
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "inherit",
          alignItems: "flex-end",
        }}
      >
        <Checkbox readOnly isChecked={customer.hasSeparateDispenseCount} />
        <FormLabel style={{ margin: 0 }}>Has Separate Dispense Count</FormLabel>
      </FormControl>
      <FormControl
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "inherit",
          alignItems: "flex-end",
        }}
      >
        <Checkbox readOnly isChecked={customer.requiresEVhr} />
        <FormLabel style={{ margin: 0 }}>requiresEVhr</FormLabel>
      </FormControl>
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Offered Services
      </Heading>
      {customer.clientId ? (
        <OfferedServices services={customer.offeredServices} />
      ) : (
        <></>
      )}
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Accounts
      </Heading>
      <Accounts accounts={customer.accounts} />
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Contact Persons
      </Heading>
      <ContactPersons contactPersons={customer.contactPersons} />
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Insurance Limits
      </Heading>
      <InsuranceLimits insuranceLimits={customer.insuranceLimits} />
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Replenishment Models
      </Heading>
      {customer.clientId ? (
        <ReplenishmentModels
          replenishmentModels={customer.replenishmentModels}
        />
      ) : (
        <></>
      )}
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Contracts
      </Heading>
      {customer.clientId ? <Contracts contracts={customer.contracts} /> : <></>}
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Escalation Groups
      </Heading>
      <EscalationGroups escalationGroups={customer.escalationGroups} />
    </form>
  );
}

function OfferedServices({ services }) {
  const [servicesList, setServicesList] = useState([]);

  useEffect(() => {
    setServicesList(services.map((elm) => ({ ...elm, expanded: false })));
  }, []);
  const expandChange = ({ dataIndex }) => {
    const _servicesList = [...servicesList];
    _servicesList[dataIndex].expanded = !_servicesList[dataIndex].expanded;
    setServicesList(_servicesList);
  };
  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "16px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Cassettes
        </Heading>

        <Grid data={dataItem.cassettes}>
          <GridColumn field="description" title="Description" />
          <GridColumn field="denomination" title="Denomination" />
          <GridColumn title="Cassette type" field="cassetteType" />
          <GridColumn title="Maker" field="maker" />
          <GridColumn title="Limit" field="limit" />
          <GridColumn
            title="Dual Scanning"
            cell={(props) => (
              <td>
                <Checkbox isChecked={props.dataItem.dualScanning} />
              </td>
            )}
          />
        </Grid>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Denomination
        </Heading>
        <Grid data={dataItem.denominations}>
          <GridColumn title="Currency" field="currency" />
          <GridColumn title="Multiple" field="multiple" />
          <GridColumn title="Shape" field="shape" />
          <GridColumn title="Version" field="version" />
        </Grid>
      </>
    );
  }
  return (
    <Grid
      data={servicesList}
      detail={DetailComponent}
      expandField="expanded"
      onExpandChange={expandChange}
    >
      <GridColumn field="serviceName" title="Service Name" />
    </Grid>
  );
}

function Accounts({ accounts }) {
  return (
    <Grid data={accounts}>
      <GridColumn title="Title" field="title" />
      <GridColumn title="Account No" field="accountNo" />
      <GridColumn title="Branch Code" field="branchCode" />
    </Grid>
  );
}

function ContactPersons({ contactPersons }) {
  return (
    <Grid data={contactPersons}>
      <GridColumn title="First Name" field="firstName" />
      <GridColumn title="Last Name" field="lastName" />
      <GridColumn title="Mobile No" field="mobileNo" />
      <GridColumn title="Personal Mobile No" field="personalMobileNo" />
      <GridColumn title="Business Contact No" field="officeNo" />
      <GridColumn title="Email" field="email" />
      <GridColumn title="Designation" field="designation" />
    </Grid>
  );
}

function InsuranceLimits({ insuranceLimits }) {
  return (
    <Grid data={insuranceLimits}>
      <GridColumn title="Type" field="type" />
      <GridColumn title="Currency" field="currency" />
      <GridColumn title="Pavement" field="pavement" />
      <GridColumn title="Van" field="van" />
      <GridColumn title="Bag" field="bag" />
    </Grid>
  );
}

function ReplenishmentModels({ replenishmentModels }) {
  const [models, setModels] = useState([]);
  useEffect(() => {
    setModels(replenishmentModels.map((elm) => ({ ...elm, expanded: false })));
  }, []);
  const expandChange = ({ dataIndex }) => {
    const _models = [...models];
    _models[dataIndex].expanded = !_models[dataIndex].expanded;
    setModels(_models);
  };

  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "16px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Denominations
        </Heading>

        <Grid data={dataItem.denominations}>
          <GridColumn field="denomination" title="Denomination" />
          <GridColumn field="noOfCassettes" title="Cassettes" />
          <GridColumn field="noOfNotes" title="Notes" />
        </Grid>
      </>
    );
  }
  return (
    <Grid
      data={models}
      detail={DetailComponent}
      expandField="expanded"
      onExpandChange={expandChange}
    >
      <GridColumn title="Code" field="code" />
    </Grid>
  );
}

function Contracts({ contracts }) {
  const [contractList, setContractList] = useState([]);
  useEffect(() => {
    setContractList(contracts.map((elm) => ({ ...elm, expanded: false })));
  }, []);
  const expandChange = ({ dataIndex }) => {
    const _contractList = [...contractList];
    _contractList[dataIndex].expanded = !_contractList[dataIndex].expanded;
    setContractList(_contractList);
  };

  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Contract SLAs
        </Heading>
        <Grid data={dataItem.contractSLAs}>
          <GridColumn field="region" title="Region" />
          <GridColumn field="serviceType" title="Service Type" />
          <GridColumn field="activityType" title="Activity Type" />
          <GridColumn field="responseTime" title="Response Time(mins)" />
          <GridColumn field="attendedTime" title="Attended Time(mins)" />
          <GridColumn field="resolutionTime" title="Resolution Time(mins)" />
        </Grid>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",

            padding: "10px 0px",
            margin: 0,
          }}
        >
          Invoicing Catalog
        </Heading>
        <Grid data={dataItem.invoicingCatalogs}>
          <GridColumn field="invoicingCode" title="Code" />
          <GridColumn field="currency" title="Currency" />
          <GridColumn field="rate" title="rate" />
          <GridColumn field="discount" title="Discount" />
        </Grid>
      </>
    );
  }
  return (
    <Grid
      data={contractList}
      detail={DetailComponent}
      expandField="expanded"
      onExpandChange={expandChange}
    >
      <GridColumn field="contractCode" title="Contract Code" />
      <GridColumn field="autoRenewFor" title="Auto Renew For" />
      <GridColumn
        field="startDate"
        title="Start Date"
        cell={({ dataItem }) => (
          <td>{moment(dataItem.startDate).format(dateFormat)}</td>
        )}
      />
      <GridColumn
        field="endDate"
        title="End Date"
        cell={({ dataItem }) => (
          <td>{moment(dataItem.endDate).format(dateFormat)}</td>
        )}
      />
      <GridColumn field="status" title="Status" />
      <GridColumn
        field="autoRenew"
        cell={({ dataItem }) => (
          <td>
            <Checkbox isChecked={dataItem.autoRenew} />
          </td>
        )}
      />
    </Grid>
  );
}
function EscalationGroups({ escalationGroups }) {
  return (
    <Grid data={escalationGroups}>
      <GridColumn title="Region" field="region" />
      <GridColumn title="Route" field="routeNo" />
      <GridColumn title="Escalation Level" field="escalationLevel" />
      <GridColumn
        title="In App Recipient"
        cell={({ dataItem }) => <td>{dataItem.inAppRecipients.join(",")}</td>}
      />
      <GridColumn
        title="Email Recipient"
        cell={({ dataItem }) => <td>{dataItem.emailRecipients.join(",")}</td>}
      />
      <GridColumn
        title="Call Recipient"
        cell={({ dataItem }) => <td>{dataItem.callRecipients.join(",")}</td>}
      />
    </Grid>
  );
}
